import { render, staticRenderFns } from "./openNewCourse.vue?vue&type=template&id=f0023ebc&scoped=true&lang=pug"
import script from "./openNewCourse.vue?vue&type=script&lang=ts"
export * from "./openNewCourse.vue?vue&type=script&lang=ts"
import style0 from "./openNewCourse.vue?vue&type=style&index=0&id=f0023ebc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0023ebc",
  null
  
)

export default component.exports